import { Image } from '@chakra-ui/react';
import { DialogBody, DialogCloseTrigger, DialogContent, DialogRoot } from '@/components/ui/dialog';

interface ImageLightboxProps {
  src: string;
  alt?: string;
  isOpen: boolean;
  onClose: () => void;
}

// Quick full-size viewer for an image thumbnail (course covers, etc.).
// Controlled: the caller owns the open state and makes its thumbnail the trigger.
export default function ImageLightbox({ src, alt = '', isOpen, onClose }: ImageLightboxProps) {
  return (
    <DialogRoot lazyMount open={isOpen} onOpenChange={onClose} size='xl' placement='center'>
      <DialogContent bg='bg.panel' p={2}>
        <DialogCloseTrigger />
        <DialogBody p={0}>
          <Image
            src={src}
            alt={alt}
            w='100%'
            maxH='80vh'
            objectFit='contain'
            borderRadius='md'
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
}
